<template>
  <div>
    <div class="c-topics-header">
      <progress-bar
        class="c-topics-header__progress"
        :value="numberOfResults"
        :max="numberOfTopicsWithoutNoOpinion"
      >Progress</progress-bar>
      <navigation-button
        class="c-topics-header__action"
        to="results"
        v-if="numberOfResults > 0"
        @click="saveResults"
      >Ontdek je resultaten</navigation-button>
    </div>
    <h1 class="c-heading-1">Trends</h1>
    <alert-box v-if="numberOfResults == numberOfTopicsWithoutNoOpinion && numberOfResults > 0">
      <p>
        Proficiat, je hebt alle trends doorlopen! Klik op
        <strong>Ontdek je resultaten</strong> om door te gaan naar de resultatenpagina.
      </p>
    </alert-box>
    <p
      v-if="numberOfResults < numberOfTopicsWithoutNoOpinion"
    >Hieronder vind je {{numberOfTopicsWithoutNoOpinion}} toekomsttrends die voor jouw activiteit belangrijk kunnen zijn. Ken je deze trends? Hoe schat jij de impact van deze trends op je activiteit in? We moedigen je sterk aan om de {{numberOfTopicsWithoutNoOpinion}} trends te ontdekken en op basis van je antwoorden formuleren wij een kort advies.</p>
    <p
      v-if="numberOfResults < numberOfTopicsWithoutNoOpinion"
    >Wanneer je met alle trends hebt kennis gemaakt, dan kan je de Future Forward scan afronden. Eén van onze Future Forward-coaches begeleidt je dan verder.</p>
    <TopicsList
      class="c-topics--completed"
      v-if="numberOfResults > 0"
      :items="sortedTopics.hasResults"
    />
    <p
      class="c-topics__instructions"
      v-if="numberOfResults > 0 && numberOfResults < numberOfTopicsWithoutNoOpinion"
    >Kies een trend om verder te gaan.</p>
    <TopicsList
      class="c-topics--notcompleted"
      v-if="numberOfResults < numberOfTopicsWithoutNoOpinion"
      :items="sortedTopics.hasNoResults"
      :showButtons="false"
    />
    <p class="c-topics__instructions">Trends zonder mening</p>
    <TopicsList
      class="c-topics--completed c-topics--no-opinion"
      :items="sortedTopics.hasResultsWithoutOpinion"
      :showButtons="false"
    />
    <div class="c-toolbar">
      <div class="c-toolbar__right">
        <navigation-button
          to="results"
          v-if="numberOfResults > 0"
          @click="saveResults"
        >Ontdek je resultaten</navigation-button>
      </div>
    </div>
  </div>
</template>

<script>
import AlertBox from "../components/AlertBox.vue";
import NavigationButton from "../components/NavigationButton.vue";
import ProgressBar from "../components/ProgressBar.vue";
import TopicCircle from "../components/TopicCircle.vue";
import topicMixins from "../mixins/Topics.js";
import TopicsList from "../components/TopicsList";
export default {
  mixins: [topicMixins],
  components: {
    AlertBox,
    NavigationButton,
    ProgressBar,
    TopicCircle,
    TopicsList
  },
  computed: {
    topics() {
      return this.$store.getters.filteredTopics;
    },
    sortedTopics() {
      let result = {
        hasResults: {},
        hasResultsWithoutOpinion: {},
        hasNoResults: {}
      };
      for (let key in this.topics) {
        if (this.topics.hasOwnProperty(key)) {
          if (this.scores[key].topicHasResults === true) {
            if (this.hasNoOpinion(key)) {
              result.hasResultsWithoutOpinion[key] = this.topics[key];
            } else {
              result.hasResults[key] = this.topics[key];
            }
          } else if (this.scores[key].topicHasResults === false) {
            // exclude category algemeen (add them last)
            if (this.topics[key].category !== "algemeen") {
              result.hasNoResults[key] = this.topics[key];
            }
          }
        }
      }
      for (let key in this.topics) {
        if (this.topics.hasOwnProperty(key)) {
          if (this.scores[key].topicHasResults === false) {
            // only category algemeen
            if (this.topics[key].category === "algemeen") {
              result.hasNoResults[key] = this.topics[key];
            }
          }
        }
      }
      return result;
    },
    numberOfResults() {
      return Object.keys(this.sortedTopics.hasResults).length;
    },
    numberOfTopics() {
      return Object.keys(this.topics).length;
    },
    numberOfTopicsWithoutNoOpinion() {
      return (
        Object.keys(this.topics).length -
        Object.keys(this.sortedTopics.hasResultsWithoutOpinion).length
      );
    }
  },
  methods: {
    saveResults() {
      this.$store.commit("updateProgress", "TRENDS_COMPLETED");
      this.$store.dispatch("updateDatabaseRecord");
    }
  },
  mounted() {
    console.debug("TRENDS_MOUNTED", { vm: this });
  }
};
</script>

<style lang="scss">
@import "../assets/styles/variables.scss";

.c-topics-header {
  display: flex;
  margin-bottom: 4rem;
}

.c-topics-header__progress {
  flex: 1 1 auto;
}

.c-topics-header__action {
  flex: none;
  margin-left: 2.4rem;
}

.c-topics--completed {
  border-bottom: 1px solid rgba(#fff, 0.2);
  padding-bottom: 2.4rem;

  &:last-child {
    border-bottom: 0;
  }
}

.c-topics--notcompleted {
  border-bottom: 1px solid rgba(#fff, 0.2);
  margin-bottom: 3.2rem;
  margin-top: 3.2rem;
}

.c-topics__instructions {
  margin-top: 2.4rem;
  text-align: center;
}

@media (max-width: $bp-medium) {
  .c-topics-header {
    margin-bottom: 2.4rem;
  }
}
</style>
